import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import makeStyles from '@material-ui/styles/makeStyles';
import { connect } from 'react-redux';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import sweetAlertStyle from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx';
import SweetAlert from 'react-bootstrap-sweetalert';
import { compose } from 'redux';

import MailNotificationCardSectionView from './MailNotificationCardSection.view';

const useStyles = makeStyles({
  ...extendedFormsStyle,
  ...buttonsStyle,
  ...sweetAlertStyle,
});

const MailNotificationCardSectionContainer = ({
  mailForAdmin,
  title,
  mailing,
  defaultConfigFromBrand,
  brand,
  setAllowToChangedElements,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [state, setState] = useState({
    mailForAdmin,
    mailing,
    confirmModal: null,
    defaultConfigFromBrand,
  });

  const renderAlert = (onConfirm, onCancel) => {
    const confirmModal = (
      <SweetAlert
        warning={true}
        title={t('notify.resetContent')}
        onConfirm={() => onConfirm()}
        onCancel={() => onCancel()}
        confirmBtnCssClass={`${classes.button} ${classes.success}`}
        cancelBtnCssClass={`${classes.button} ${classes.danger}`}
        confirmBtnText={t('notify.yes')}
        cancelBtnText={t('notify.no')}
        showCancel={true}
      />
    );

    setState(prev => ({ ...prev, confirmModal }));
  };

  const props = {
    state,
    setState,
    renderAlert,
    title,
    brand,
    setAllowToChangedElements,
  };

  return <MailNotificationCardSectionView props={props} />;
};

const mapStateToProps = state => ({
  brand: state.Auth.selectedBrand,
});

const enhance = compose(connect(mapStateToProps, null));

export default enhance(MailNotificationCardSectionContainer);
